import React from "react";
import { useNavigate } from "react-router-dom";

interface NavigateEntityProps {
  path: string;
  className?: string;
  children: React.ReactNode;
  disabledClick?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const NavigateEntity: React.FC<NavigateEntityProps> = ({
  path,
  className,
  children,
  onClick,
  disabledClick,
}) => {
  const isLiteApp = window.location.pathname.startsWith("/lite");
  const basePath = isLiteApp ? "/lite" : "";
  const url = `${basePath}${path}`;
  
  if (disabledClick) {
    return <a className={className}>{children}</a>;
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>) => {
    e.preventDefault()
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <a href={url} className={className} onClick={handleClick}>
      {children}
    </a>
  );
};
